import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

const CustomSearch = ({
    placeholder = "Search",
    fullWidth = false,
    md = "25ch",
    value,
    onChange
}) => {

    return (
        <FormControl
            fullWidth={fullWidth}
            variant="outlined"
            sx={{
                width: fullWidth
                    ? '100%'
                    : { xs: '100%', md: md },
            }}
        >
            <OutlinedInput
                size="small"
                id="search"
                placeholder={placeholder}
                autoComplete='off'
                value={value}              // ✅ controlled value
                onChange={(e) => onChange(e.target.value)} // ✅ trigger function
                sx={{ flexGrow: 1 }}
                startAdornment={
                    <InputAdornment position="start" sx={{ color: 'text.primary' }}>
                        <SearchRoundedIcon sx={{ fontSize: 17, color: "#94A3B8" }} />
                    </InputAdornment>
                }
                inputProps={{
                    'aria-label': 'search',
                }}
            />
        </FormControl>
    );
}

export default CustomSearch;